import React from 'react';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { LocaleProvider } from 'antd';

/**
 * 国际化组件
 * 
 * @class Intl
 * @extends {React.Component}
 */
class Intl extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { intlr } = this.props;
        return (
            <IntlProvider locale={intlr.langKey} messages={intlr.messages}>
                <LocaleProvider>
                    {this.props.children}
                </LocaleProvider>
            </IntlProvider>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr
});

export default connect(mapStateToProps)(Intl);
